export default __webpack_public_path__ + "static/media/hero.9f367b09.jpg";